import { Component, OnInit, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { HTTPStatus } from './Common/app-token-handler';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewChecked {
    userName: string;
    iSLoading: boolean;

    constructor(private cdRef: ChangeDetectorRef, private httpStatus: HTTPStatus) {
        this.httpStatus.getHttpStatus().subscribe((status: boolean) => { this.iSLoading = status; });
    }
    ngOnInit() {
    }

    ngAfterViewChecked() {

        this.httpStatus.getHttpStatus().subscribe((status: boolean) => {
            this.iSLoading = status;
        });
    }
}
